import { get, post, put, del } from './requests'

const resourcePath = 'documents'
const documentsSharedResourcePath = 'share'

export function listDocuments () {
  return get(resourcePath)
}

export function searchDocuments ({ queryParams }) {
  return get(resourcePath, queryParams)
}

export function showDocument (id) {
  return get(`${resourcePath}/${id}`)
}

export function createDocument (data) {
  return post(`${resourcePath}`, { document: data })
}

export function createDocumentFromTemplates (templates, documentId = null) {
  return post(`document_templates/documents`, { templates, documentId })
}

export function copyDocument (id, notice) {
  return post(`${resourcePath}/${id}/copy`, { notice })
}

export function updateDocument (data) {
  return put(`${resourcePath}/${data.id}`, { document: data })
}

export function deleteDocument (id) {
  return del(`${resourcePath}/${id}`)
}

export function assignPagesToDocument (payload) {
  return post(`${resourcePath}/assign_pages`, payload)
}

export function archiveDocuments (ids) {
  return post(`${resourcePath}/archive`, {
    document_ids: [ids]
  })
}

export function applyDocumentLabels (id, labelIds) {
  return post(`${resourcePath}/${id}/apply_labels`, { labelIds })
}

export function updateAndResendDocument (id) {
  return post(`${resourcePath}/${id}/update_and_resend`)
}

export function archiveAndExpireDocument (id) {
  return post(`${resourcePath}/${id}/archive_and_expire`)
}

export function declineDocument (data) {
  return post(`${resourcePath}/${data.id}/declines`, { decline: data })
}

export function markAsSignedAndCompleted (id, file, notifyRecipients) {
  return post(`${resourcePath}/${id}/signed_and_completed`, { document: { id, file, notifyRecipients } })
}

export function reassignSigner ({ name, email, message }) {
  return post(`${resourcePath}/reassign`, { reassign: { name, email, message } })
}

export function createSigningDocumentLinks (id) {
  return post(`${resourcePath}/${id}/signing_document_links`)
}

export function createSharedDocument (id) { return post(`${resourcePath}/${id}/${documentsSharedResourcePath}`, { id }) }

export function rollbackSharedDocument (id) { return del(`${resourcePath}/${id}/${documentsSharedResourcePath}`) }

export function quickSend (id, params) {
  return post(`${resourcePath}/${id}/quick_send`, params)
}
